import { render, staticRenderFns } from "./BreadcrumbMobile.vue?vue&type=template&id=97a6991a&scoped=true"
import script from "./BreadcrumbMobile.vue?vue&type=script&lang=js"
export * from "./BreadcrumbMobile.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbMobile.vue?vue&type=style&index=0&id=97a6991a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a6991a",
  null
  
)

export default component.exports